// extracted by mini-css-extract-plugin
export default {"price":"A6-z","onSale":"B6-z","msrpLabelPrice":"C6-z","msrpLabel":"D6-z","originalPrice":"E6-z","percentOff":"F6-z"};